import Vue from 'vue'
import VueRouter from 'vue-router'
import MapPage from '../views/Map.vue'
import Condition from '../views/TableCondition.vue'
import History from '../views/TableHistory.vue'
import Notification from '../views/NotificationPage.vue'
import Administrator from '../views/Administrator.vue'
import AddDevice from '../views/AddDevice.vue'
import Recap from '../views/Recap.vue' 
import Login from '../views/LogIn.vue'
import Register from '../views/Register.vue'
import Confirmation from '../views/ConfirmPage.vue'
import Logged from '../views/Logged.vue'
import Calibrate from '../views/Calibrate.vue'
import Download from '../views/Download.vue'
import RegisterDevice from '../views/RegisterDevice.vue'
import LoginPetugas from '../views/LoginPetugas.vue'
import MapPetugas from '../views/Petugas/MapPetugas.vue'
import NotificationPetugas from '../views/Petugas/NotificationPetugas.vue'
import DataPetugas from '../views/Petugas/DataPetugas.vue'
import RecapPetugas from '../views/Petugas/RecapPetugas.vue'
import ChartData from '../views/Chart.vue'
import ChartDataPetugas from '../views/Petugas/ChartPetugas.vue'
import MapGPS from '../views/MapGPS.vue'
import DownloadFile from '../views/DownloadFile.vue'
import DownloadFileMonthly from '../views/DownloadFileMonthly.vue'
import ChartTMA from '../views/TMA/ChartTMA.vue'
import AdminTMA from '../views/TMA/AdminTMA.vue'
import NotificationTMA from '../views/TMA/NotificationTMA.vue'
import MCB from '../views/MCB/MCB.vue'
import ContactUs from '../views/ContactUs.vue'


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: Logged,
    children: [
      {
        path: '',
        name: 'Map',
        component: MapPage
      },
      {
        path: '/close',
        name: 'Map',
        component: MapPage
      },
      {
        path: '/MapGPS',
        name: 'Map GPS',
        component: MapGPS
      },
      {
        path: '/Condition',
        name: 'Condition',
        component: Condition,
      },
      {
        path: '/History',
        name: 'History',
        component: History,
      },
      {
        path: '/Notification',
        name: 'Notification',
        component: Notification,
      },
      {
        path: '/NotificationTMA',
        name: 'NotificationTMA',
        component: NotificationTMA,
      },
      {
        path: '/Administrator',
        name: 'Administrator',
        component: Administrator,
      },
      {
        path: '/AdminTMA',
        name: 'AdminTMA',
        component: AdminTMA,
      },
      {
        path: '/AddDevice',
        name: 'AddDevice',
        component: AddDevice,
      },
      {
        path: '/Recap',
        name: 'Recap',
        component: Recap,
      },
      {
        path: '/DownloadFile',
        name: 'DownloadFile',
        component: DownloadFile,
      },
      {
        path: '/DownloadFileMonthly',
        name: 'DownloadFileMonthly',
        component: DownloadFileMonthly,
      },
      {
        path: '/Chart',
        name: 'Chart',
        component: ChartData,
      },
      {
        path: '/deviceCalib',
        name: 'Calibrate',
        component: Calibrate
      },
      {
        path: '/ChartTMA',
        name: 'ChartTMA',
        component: ChartTMA
      },
      {
        path: '/RegisterDevice',
        name: 'RegisterDevice',
        component: RegisterDevice
      },
      {
        path: '/MapPetugas-id=:mac&device=:jenis',
        name: 'MapPetugas',
        component: MapPetugas
      },
      {
        path: '/NotificationPetugas-id=:mac&device=:jenis',
        name: 'NotificationPetugas',
        component: NotificationPetugas
      },
      {
        path: '/DataPetugas-id=:mac&device=:jenis',
        name: 'DataPetugas',
        component: DataPetugas
      },
      {
        path: '/RecapPetugas-id=:mac&device=:jenis',
        name: 'RecapPetugas',
        component: RecapPetugas
      },
      {
        path: '/ChartPetugas-id=:mac&device=:jenis',
        name: 'ChartPetugas',
        component: ChartDataPetugas
      },
      {
        path: '/MCB',
        name: 'MCB Control',
        component: MCB
      },
      {
        path: '/ICCIDList',
        name: 'ICCIDList',
        component: () => import('../views/ICCIDList.vue')
      }
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/register',
    name: 'Register',
    component: Register,
  },
  {
    path: '/confirm',
    name: 'Confirmation',
    component: Confirmation,
  },
  {
    path: '/download',
    name: 'Download',
    component: Download,
  },
  {
    path: '/contactUs',
    name: 'ContactUs',
    component: ContactUs,
  },
  {
    path: '/loginPetugas',
    name: 'Login Petugas',
    component: LoginPetugas,
  }
]

const router = new VueRouter({
  routes
})

export default router
